(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.rsg');
    if (!root) return;

    initTabs(root);
    initSizeForm(root);
    initAnchorScroll(root);
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('.rsg-tab');
    var panels = root.querySelectorAll('.rsg-panel');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var targetPanel = root.querySelector('.rsg-panel[data-tab="' + target + '"]');
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  }

  var UNDER_TABLE = [
    { min: 62.5, max: 67.4, size: '65' },
    { min: 67.5, max: 72.4, size: '70' },
    { min: 72.5, max: 77.4, size: '75' },
    { min: 77.5, max: 82.4, size: '80' }
  ];

  var CUP_TABLE = [
    { min: 7.4, max: 9.9, cup: 'A' },
    { min: 10, max: 12.4, cup: 'B' },
    { min: 12.5, max: 14.9, cup: 'C' },
    { min: 15, max: 17.4, cup: 'D' },
    { min: 17.5, max: 19.9, cup: 'E' },
    { min: 20, max: 22.4, cup: 'F' },
    { min: 22.5, max: 25, cup: 'G' }
  ];

  function computeBraSize(top, under) {
    if (isNaN(top) || isNaN(under)) return null;
    var diff = Math.round((top - under) * 10) / 10;
    var u = null;
    for (var i = 0; i < UNDER_TABLE.length; i++) {
      if (under >= UNDER_TABLE[i].min && under <= UNDER_TABLE[i].max) {
        u = UNDER_TABLE[i].size;
        break;
      }
    }
    var c = null;
    for (var j = 0; j < CUP_TABLE.length; j++) {
      if (diff >= CUP_TABLE[j].min && diff <= CUP_TABLE[j].max) {
        c = CUP_TABLE[j].cup;
        break;
      }
    }
    if (!u || !c) return null;
    return c + u;
  }

  function initSizeForm(root) {
    var topInput = root.querySelector('#rsg-top');
    var underInput = root.querySelector('#rsg-under');
    var resultEl = root.querySelector('.rsg-form__result-value');
    var errorEl = root.querySelector('.rsg-form__result-error');
    if (!topInput || !underInput || !resultEl) return;

    function roundToDecimal(input) {
      var raw = parseFloat(input.value);
      if (isNaN(raw)) {
        input.value = '';
        return null;
      }
      var rounded = Math.round(raw * 10) / 10;
      input.value = rounded.toString();
      return rounded;
    }

    function updateResult() {
      var top = parseFloat(topInput.value);
      var under = parseFloat(underInput.value);
      if (isNaN(top) || isNaN(under)) {
        resultEl.textContent = '???';
        resultEl.hidden = false;
        if (errorEl) errorEl.hidden = true;
        return;
      }
      var size = computeBraSize(top, under);
      if (size) {
        resultEl.textContent = size;
        resultEl.hidden = false;
        if (errorEl) errorEl.hidden = true;
      } else {
        resultEl.hidden = true;
        if (errorEl) errorEl.hidden = false;
      }
    }

    topInput.addEventListener('input', updateResult);
    underInput.addEventListener('input', updateResult);
    topInput.addEventListener('blur', function () { roundToDecimal(topInput); updateResult(); });
    underInput.addEventListener('blur', function () { roundToDecimal(underInput); updateResult(); });
  }

  function initAnchorScroll(root) {
    var anchors = root.querySelectorAll('.rsg-detail__anchor, .rsg-how__anchor');
    anchors.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
